import { render, staticRenderFns } from "./multi-select.vue?vue&type=template&id=19a9eeaa&scoped=true&"
import script from "./multi-select.ts?vue&type=script&lang=ts&"
export * from "./multi-select.ts?vue&type=script&lang=ts&"
import style0 from "./multi-select.scss?vue&type=style&index=0&id=19a9eeaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a9eeaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
